import React from "react";
import "../styles/CurrentUserDetails.css"; // Use the existing styles
import "../styles/HeaderWithUserDetails.css"; // Use the existing styles

const HeaderWithUserDetails = ({ currentUser }) => {
  const isValidPhotoUrl = (url) => {
    const validExtensions = /\.(jpg|JPG|png|PNG)$/;
    return validExtensions.test(url);
};
const getInitials = (name) => {
  if (!name) return "";
  const nameArray = name.split(" ");
  return nameArray.length > 1
    ? nameArray[0][0] + nameArray[1][0] // First letter of first and last name
    : nameArray[0][0]; // First letter of the first name if only one name
};

  return (
    <header className="header">
      <div className="current-user-details">
        <div className="avatar">
          {currentUser?.photo && isValidPhotoUrl(currentUser?.photo)? (
            <img src={currentUser.photo} alt="User Avatar" />
          ) : (
            <span>{getInitials(
              currentUser.firstName + " " + currentUser.lastName
            ) || "U"}</span>
          )}
        </div>
        <div className="user-info">
          <span className="loggedin-user-name">{currentUser?.name || "Guest"}</span>
          <span className={`user-status ${currentUser?.online ? "online" : "offline"}`}>
            {currentUser?.online ? "Online" : "Offline"}
          </span>
        </div>
      </div>
    </header>
  );
};

export default HeaderWithUserDetails;
